function normalizeStatus(value) {
  return String(value || '').trim().toLowerCase()
}

export function readReadyForAdminFinalApproval(item) {
  if (!(item && typeof item === 'object')) return null

  const workflow = item.workflow && typeof item.workflow === 'object'
    ? item.workflow
    : null
  const candidates = [
    item.readyForAdminFinalApproval,
    item.committeeApprovalProgress && item.committeeApprovalProgress.readyForAdminFinalApproval,
    workflow && workflow.readyForAdminFinalApproval,
    workflow && workflow.committeeApprovalProgress && workflow.committeeApprovalProgress.readyForAdminFinalApproval
  ]

  const explicit = candidates.find((value) => typeof value === 'boolean')
  return typeof explicit === 'boolean' ? explicit : null
}

export function isReadyForAdminFinalApproval(item) {
  const explicit = readReadyForAdminFinalApproval(item)
  if (explicit !== null) return explicit
  if (!(item && typeof item === 'object')) return false

  const workflow = item.workflow && typeof item.workflow === 'object'
    ? item.workflow
    : {}
  const committeeDecision = normalizeStatus(workflow.committeeDecision || item.committeeDecision)
  const currentStep = Number(workflow.currentStep || item.currentStep || 1)
  const status = normalizeStatus(workflow.status || item.workflowStatus || item.status)

  return committeeDecision === 'approve' && currentStep >= 4 && status !== 'draft'
}
